import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { getURL } from 'helpers/utils';
import { useUrlFriendlyToParameters, useNavigateTo2, useGetURL, useLoadCCData, GetRealPath } from "helpers/urlFriendly";
import { useGetRoutes } from "helpers/commonCodes";
import Loader from "components/general/Loader";


function Selector_Language() {

    let urlP = useParams();
    let params = useUrlFriendlyToParameters();
    //Copy object in order to change 
    let paramsURL = { ...params }
    const { i18n } = useTranslation();
    const [lang, setLang] = useState(params.mirs_language);
    const previousValue = useRef(null);
    const [path, setPath] = useState();
    const [paramsUrl, setParamsUrl] = useState({});
    const [paramsUrl2, setParamsUrl2] = useState({});
    const [shouldNavigate, setShouldNavigate] = useState();
    const [show, setShow] = useState(false);
    const [loaded, setLoaded] = useState(false);
    let paramsCC = useLoadCCData(paramsUrl, loaded, setLoaded) //load common
    let dataRouters = useGetRoutes(previousValue.language)

    // Get Parameters 
    let url = useGetURL(paramsUrl2, path)
    const realPath = GetRealPath();

    useNavigateTo2(url, shouldNavigate, setShouldNavigate)//useGetURL(paramsURL, 'results')
    const navigate = useNavigate()

    const handleOnChange = (event => {
        previousValue.language = lang;
        i18n.changeLanguage(event.target.value)
        setLang(event.target.value.toUpperCase())

        //Change check if is by code 
        if (urlP.mirs_language.length > 2) {
            paramsURL.mirs_language = event.target.value.toUpperCase();
            paramsURL.mirs_competition = params.mirs_competition;
            paramsURL.mirs_discipline = params.mirs_discipline;
            paramsURL.mirs_rsc = params.mirs_rsc;
            url = getURL(paramsURL, path)
            navigate(url)
        }

    })

    useEffect(() => {
        let _path = realPath(lang);
        setPath(_path);
        paramsURL.mirs_language = lang;
        //navigate(getURL(paramsURL, path))
        if (previousValue.language && paramsURL.mirs_language && (paramsURL.mirs_language !== previousValue.language)) {
            setParamsUrl(paramsURL);
            setShow(true)

            /*
                        setTimeout(() => {
                            setParamsUrl2(paramsURL);
                        }, 1000);
            */

        }
    }, [dataRouters])


    useEffect(() => {
        if (loaded) {
            paramsURL.mirs_language = lang;
            setLoaded(false)
            setParamsUrl2(paramsURL);
        }

    }, [loaded])

    useEffect(() => {
        //Wait to CC are loaded paramsCC and url is complete translate 
        if (url && url.indexOf("undefined") === -1) {
            setShouldNavigate(true);
            setShow(false)
        }
    }, [url])




    if (show) { return <Loader className="loading" text="LOADING SELECTOR LANGUAGE Common Codes" /> }

    return (
        <>
            <div className="select">
                <select
                    //value={i18n.language}
                    value={lang?.toLowerCase()}
                    onChange={handleOnChange}>
                    <option value="eng">English</option>
                    <option value="fra">French</option>
                </select >
            </div >

        </>

    );
}
export default Selector_Language;